import React from 'react'

const ErpMainContent = () => {
    return (
        <>
            <section className="services-details-area ptb-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 services-details">
                            <div className="ml-about-content">
                                {/* <h2>
                                    Empowering Businesses through Robust ERP Software Development
                                    Services
                                </h2> */}
                                <h1>
                                    ERP Development Company : Streamline Your Business Operations
                                </h1>
                                <div className="bar" />
                                <p>
                                    We are a full-fledged <b>ERP Development Company in India</b> helping diverse industry clients to streamline different workflows and processes with a single integrated system, so that their employees can work smarter. Our in-depth understanding of different underlying models, technologies and applications and others help us guide you with the most appropriate ERP software to sync perfectly with your business lines. Our range of outsourced ERP development services in India includes:
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details-image">
                            <img loading="lazy"
                                src="assets/img/service-detail-image/epr-1.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="separate" />
                    <div className="row align-items-center">
                        <div className="col-lg-6 services-details-image">
                            <img loading="lazy"
                                src="assets/img/service-detail-image/epr-2.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                        <div className="col-lg-6 services-details">
                            <div className="ml-about-content">
                                <h2>What sets us apart in ERP Development Outsourcing?</h2>
                                <div className="bar" />
                                <p>
                                    Recuperating existing course of internal communication, Alobha Technologies’ <b>ERP Software Development </b>approach dives deep into the business
                                    logic and conceives distinct solutions for every business model.
                                    Being a progressive software development company in India having a
                                    clear-cut focus on eliminating inefficiencies, here’s what sets us
                                    apart when it comes to ERP development outsourcing services in
                                    India:
                                </p>
                                <div className="services-details-accordion">
                                    {/* <ul className="accordion">
                                        <li className="accordion-item">
                                            <a className="accordion-title" href="javascript:void(0)">
                                                Which material types can you work with?
                                            </a>
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title" href="javascript:void(0)">
                                                Is Smart Lock required for instant apps?
                                            </a>
                                        </li>
                                        <li className="accordion-item">
                                            <a className="accordion-title" href="javascript:void(0)">
                                                Can I have multiple activities in a single feature?
                                            </a>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center1 mt-3">
                        <div className="col-lg-12 services-details">
                            <div className="services-details-desc">
                                <h3>
                                    <b>We are Effective ERP Software Development Company in Noida (India)</b>
                                </h3>
                                <p>
                                    We are one of the most reliable <b>ERP Software Development Company in Noida</b> (India) and offering services globally. Alobha Technologies
                                    delivers integrated software solutions that help in business
                                    operations more efficiently. Our integrated tactic combines vision
                                    and innovation from multiple disciplines with business and industry
                                    knowledge. We develop ERP to help the clients’ access their business
                                    data from anywhere regardless of geographical limitations. Our
                                    integrated software consists of all forms of ERP solutions to manage
                                    the workload of any business firm.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-12 services-details mt-4">
                            <div className="services-details-desc">
                                <h3>
                                    <b>Get a wide range of ERP Development services with us</b>
                                </h3>
                                <p>
                                    Our main goal is to gain the chance and the responsibility to make
                                    an actual difference while serving in an IT industry. Our experts
                                    completely believe in keeping the mind on developing an extra
                                    advanced ERP solution for every client. As you know client
                                    satisfaction is our topmost priority
                                </p>
                                <p>
                                    Our developers have years of experience in ERP development and the
                                    creation of fully integrated modules for managing the labor force
                                    and workflows processes. We can deliver high-end software solutions
                                    to improve your present business processes and to track your
                                    projects and resources well.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-12 services-details mt-5 mb-5">
                            <div className="services-details-desc">
                                {/* <h3>
                                    <b>Reliable Online ERP Software</b>
                                </h3> */}
                                <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
                                    <b>Reliable Online ERP Software Development Company in India</b>
                                </h2>
                                <p>
                                    Enterprise Resource Planning systems are the special software which
                                    is developed to maintain operational planning, decrease the workload
                                    of every client and to optimize the internal business process. There
                                    are lots of ERP software available in the market, but we develop
                                    according to your needs and customize every service as per your
                                    service needs.
                                </p>
                                <p>
                                    All of our online ERP software is designed simply to take your
                                    business to the next level and beat the market competitions by their
                                    successful proven results. With the help of these Online ERP
                                    solutions, your working flow is easy and manageable in minimum time.
                                    Yes, you can say a time saver software as well. By working with
                                    various companies, we make a successful portfolio as an ERP Software
                                    Development Company in India and also build great client
                                    relationships. We have a range of online software like Hospital
                                    management software, online school management software, student
                                    management, etc. Are you ready to get fully integrated and
                                    customizable software solutions for your business?
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc">
                                <h3>
                                    <b>Maximize your business faster</b>
                                </h3>
                                <p>
                                    We maximize your business with our Best Software services. We are
                                    dealing in almost every industry related to Firm, Hospital
                                    management, point of sales, Library Management, school management,
                                    collage management, IT help desk, and many more. You can easily
                                    manage your workload with these custom-made ERP solutions. Here we
                                    have a long list of various features integrated into our solutions.
                                </p>
                                <h3>Customize Business needs</h3>
                                <p>
                                    We can customize the software features as per your requirements. If
                                    you want to add any of the pages, Developer will provide you full
                                    support.
                                </p>
                                <h3>Easy to use</h3>
                                <p>
                                    All of our software is simple, best, and easy to use. You can easily
                                    operate them, there is no need to require any special skills.
                                </p>
                                <h3>Real-time access to get data from any device</h3>
                                <p>
                                    If you have internet access you can directly access the information
                                    which you save in your ERP software.
                                </p>
                                <h3>Mobile friendly functions.</h3>
                                <p>
                                    Mobile friendly is one of the best functions we use today. You can
                                    access your software easily through mobile.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details ">
                            <div className="services-details-desc">
                                <h3>
                                    <b>Sales and integrated analytics</b>
                                </h3>
                                <p>
                                    At a particular page, you can easily check the details of your sales
                                    and integrated analytics is also added for your help.
                                </p>
                                <h3>Social media availability</h3>
                                <p>
                                    In daily life, Social media is known by everyone. We maintain the
                                    right place for social media on software.
                                </p>
                                <h3>Multiple language support</h3>
                                <p>All of our software is available in all supported languages.</p>
                                <h3>Scalability</h3>
                                <p>
                                    We make changes in the design of the page or any particular click
                                    action according to the customer's need.
                                </p>
                                <h3>High customization capabilities</h3>
                                <p>
                                    We give you full support on ERP solution customization. We develop
                                    with high Customization capabilities.
                                </p>
                                <h3>Security</h3>
                                <p>
                                    Security is one of the main aspects of every business deal. With a
                                    new Software, you get better consistency, reliability, accuracy, and
                                    data security. You can give security on any of the modules.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center1 mt-5">
                        <div className="col-lg-12 services-details">
                            <div className="services-details-desc">
                                <h3>
                                    <b>Work with the Greatest Efforts</b>
                                </h3>
                                <p>
                                    We have a successful portfolio of various projects worldwide. Our
                                    ERP solutions are accurate and provide better efficiency at work. A
                                    team of developers ready to support you at 24*7 service and solve
                                    your issues by understanding the problem. We always offer
                                    Budget-friendly services and provide you a complete solution as per
                                    your requirements.
                                </p>
                                {/* <h3>Why Alobha for your ERP Solutions?</h3> */}
                                <h4 style={{ fontSize: "20px", marginBottom: "15px", fontFamily: " Montserrat" }}>Why Alobha for your ERP Development service?</h4>
                                <p>
                                    In software development, we use an integrated approach to develop
                                    customizable software for your online firm. Being a progressive ERP
                                    software development company in India we have a clear focus on
                                    working on the best development phase and better understanding to
                                    eliminate the inefficiencies and resolve the issue. These are some
                                    of our best strategies which separate us in the online Market.
                                </p>
                                <ul className="text_color">
                                    <li>
                                        Having a team of experts who have completed more than 500 ERP
                                        Software to date.
                                    </li>
                                    <li>Develop Hassle free ERP solutions</li>
                                    <li>
                                        We always offer extraordinary coding quality with complete client
                                        satisfaction.
                                    </li>
                                    <li>On-time project delivery with an effective approach.</li>
                                    <li>Always offer budget-friendly projects.</li>
                                </ul>
                                <br />
                                {/* <h3 class="text-center">Are you ready to work with us?</h3>	 */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default ErpMainContent